import styled from "@emotion/styled";
import { genericStyles } from "../../../constant";

export const StyledTopicModalDiv = styled.div`
  .questions-container {
    //@ts-ignore
    max-height: ${({ isWorkflow }) => (isWorkflow ? "60dvh" : "35dvh")};
    overflow: auto;
  }

  .question-header {
    margin-bottom: 12px;
  }

  .question-number {
    font-weight: 500;
    font-size: 14px;
    color: ${genericStyles.primaryColor};
  }

  .remove-btn {
    color: #ff4d4f;
    cursor: pointer;
    font-size: 20px;
  }

  .option-item {
    margin-bottom: 8px;
    .anticon {
      font-size: 25px;
    }
  }

  .option-item .ant-space {
    width: 100%;
  }

  .add-question-btn {
    width: 100%;
    height: 36px;
    margin: 8px 0px 16px 0px;
  }
`;

export const StyledQuestionsContainer = styled.div`
  max-height: 70dvh;
  overflow: auto;
  margin-top: 20px;

  .collapse-wrapper {
    background: transparent;
    border: none;
  }

  .ant-collapse-item {
    background: white;
    border-radius: 12px !important;
    margin-bottom: 8px;
    border: 1px solid #e5e7eb !important;
    overflow: hidden;
    transition: all 0.6s ease;
  }

  .ant-collapse-item:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }

  .ant-collapse-item.dragging {
    opacity: 0.5;
    transform: scale(0.98);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }

  .ant-collapse-item.drag-over {
    border-color: ${genericStyles.primaryColor} !important;
    background: #eff6ff;
  }

  .ant-collapse-header {
    padding: 14px 20px !important;
    background: white;
    border-radius: 12px;
  }

  .panel-header {
    gap: 14px;
  }

  .drag-handle {
    cursor: grab;
    font-size: 18px;
    color: #9ca3af;
    transition: color 0.2s;
    padding: 4px;
  }

  .drag-handle:hover {
    color: #4b5563;
  }

  .drag-handle:active {
    cursor: grabbing;
  }

  .question-icon {
    font-size: 22px;
    min-width: 24px;
  }

  .question-icon.string-type {
    color: #10b981;
  }

  .question-icon.dropdown-type {
    color: ${genericStyles.primaryColor};
  }

  .question-info {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .question-number {
    font-size: 15px;
    font-weight: 500;
    width: 100px;
    color: #1f2937;
  }

  .question-type-tag {
    font-size: 12px;
    font-weight: 500;
    padding: 2px 10px;
    border-radius: 6px;
  }

  .ant-collapse-content {
    background: #f9fafb;
    border-top: 1px solid #e5e7eb;
  }

  .ant-collapse-content-box {
    padding: 20px !important;
  }

  .question-text {
    font-size: 15px;
    color: #374151;
    line-height: 1.6;
    margin-bottom: 4px;
  }

  .options-section {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #e5e7eb;
  }

  .options-label {
    font-size: 13px;
    font-weight: 500;
    color: #6b7280;
    margin-bottom: 10px;
    display: block;
  }

  .options-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .option-tag {
    font-size: 13px;
    padding: 6px 12px;
    border-radius: 6px;
    background: #e0e7ff;
    color: ${genericStyles.primaryColor};
    border: 1px solid #c7d2fe;
  }

  .drag-instruction {
    font-size: 12px;
    margin-bottom: 10px;
  }
`;
